// Imports
import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useSectionUSPData } from "@queries"
import { Section } from "@layout"

export const USPSection = () => {
  const { items, sectionIllustration, subtitle, title } = useSectionUSPData()
  const img = getImage(sectionIllustration)
  return (
    <Section name="usp">
      <div className="usp-container">
        <div className="usp-container__left">
          <h1> {title} </h1>
          <h5> {subtitle} </h5>

          <div className="usp-items">
            {items.map((item, index) => {
              return (
                <div className="usp-items__item" key={index}>
                  <img src={item.illustration.url} alt={item.title} />
                  <div>
                    <h5> {item.title} </h5>
                    <span> {item.shortDescription.shortDescription} </span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className="usp-illustration">
        <GatsbyImage image={img} alt="USP illustration" />
      </div>
    </Section>
  )
}
